/* eslint-disable */

export default {
  // global
  LOGO_RED: require('./icons/icon_logo_red.svg'),
  LOGO_WHITE: require('./icons/icon_logo_white.png'),
  PHOTO: require('./icons/icon_photos.svg'),
  SIGN_OUT: require('./icons/icon_signout.svg'),
  SPINNER: require('./icons/icon_loading_spinner.gif'),
  DOTTED_BACKGROUND: require('./images/img_dotted_background.png'),
  COACHING_1: require('./images/img_coaching-1.png'),
  COACHING_2: require('./images/img_coaching-2.png'),
  DOWN_ARROW_RED: require('./icons/icon_down_arrow_red.svg'),
  ASTERISK_RED: require('./icons/icon_asterisk_red.svg'),
  CAMERA_RED: require('./icons/icon_camera_red.svg'),
  PLAY_ICON: require('./play_image.svg'),
  GIPHY_ICON: require('./GIPHY_ICON.png'),

  // sidebar
  SIDEBAR_CITYSCAPE: require('./images/img_sidebar_cityscape.png'),
  SIDEBAR_CHAT: require('./icons/icon_sidebar_chat.svg'),
  SIDEBAR_PROFILE: require('./icons/icon_sidebar_profile.svg'),
  SIDEBAR_ONBOARDING: require('./icons/icon_sidebar_onboarding.svg'),

  // chat
  CHAT_HEADER_BACKGROUND: require('./images/img_chat_header.png'),

  // onboarding
  ONBOARDING_HEADER_BACKGROUND1: require('./images/img_onboarding_header_bg1.png'), //Basics
  ONBOARDING_HEADER_BACKGROUND2: require('./images/img_onboarding_header_bg4.png'), //Getting to know you
  ONBOARDING_HEADER_BACKGROUND3: require('./images/img_onboarding_header_bg7.png'), //Change
  ONBOARDING_HEADER_BACKGROUND4: require('./images/img_onboarding_header_bg2.png'), //Fitness
  ONBOARDING_HEADER_BACKGROUND5: require('./images/img_onboarding_header_bg3.png'), //Nutrition
  ONBOARDING_HEADER_BACKGROUND6: require('./images/img_onboarding_header_bg6.png'), //Lifestyle/Mindset
  ONBOARDING_HEADER_BACKGROUND7: require('./images/img_onboarding_header_bg5.png'), //Finish
  ONBOARDING_ROUND1: require('./images/img_onboarding_round1.png'),
  ONBOARDING_ROUND2: require('./images/img_onboarding_round2.png'),
  ONBOARDING_ROUND3: require('./images/img_onboarding_round3.png'),
  ONBOARDING_ROUND4: require('./images/img_onboarding_round4.png'),
  ONBOARDING_ROUND5: require('./images/img_onboarding_round5.png'),
  ONBOARDING_ROUND6: require('./images/img_onboarding_round6.png'),
  ONBOARDING_ROUND7: require('./images/img_onboarding_round7.png'),
  ONBOARDING_COACH: require('./images/img_onboarding_header_bg_coach.png'),
  ONBOARDING_EQUIPMENTS: require('./images/img_onboarding_header_bg_equipments.png'),
  ONBOARDING_HEADER_BACKGROUND_MOBILE: require('./images/img_onboarding_header_bg_mobile.png'),
  ONBOARDING_HEADER_BACKGROUND_MOBILE2: require('./images/img_onboarding_header_bg_mobile_group4.png'),
  ONBOARDING_HEADER_BACKGROUND_MOBILE3: require('./images/img_onboarding_header_bg_mobile_group7.png'),
  ONBOARDING_HEADER_BACKGROUND_MOBILE4: require('./images/img_onboarding_header_bg_mobile_group2.png'),
  ONBOARDING_HEADER_BACKGROUND_MOBILE5: require('./images/img_onboarding_header_bg_mobile_group3.png'),
  ONBOARDING_HEADER_BACKGROUND_MOBILE6: require('./images/img_onboarding_header_bg_mobile_group6.png'),
  ONBOARDING_HEADER_BACKGROUND_MOBILE7: require('./images/img_onboarding_header_bg_mobile_group5.png'),
  ONBOARDING_WAIVER_CLIPBOARD: require('./images/img_clipboard.png'),
  ONBOARDING_SUCCESS_FISTBUMP: require('./images/img_fistbump.png'),

  //loading
  NF_LOADING_GRADIENT: require('../shared/nf-loading-gradient.gif'),
};
